import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nro_item", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nro_item + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombres", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombres + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.nombres + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ap_paterno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_paterno + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ap_materno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_materno + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_presentacion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_presentacion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_tramite", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_tramite + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("anios", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.anios + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("meses", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.meses + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

             cf.registerFilter("dias", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.dias + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
       
            return cf.runFilters();
        },

        filterNroItem(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: val
            });
        },
        filterNombres(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: val
            });
        },
        filterApPaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: val
            });
        },
        filterApMaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: val
            });
        },
        filterFechaPresentacion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_presentacion: val
            });
        },
        filterFechaTramite(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_tramite: val
            });
        },
        filterAnios(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                anios: val
            });
        },
        filterMeses(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                meses: val
            });
        },
        filterDias(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_presentacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_tramite: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                anios: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                meses: ""
            });

            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                dias: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/lista_personal_cas/mixins/filtros.js